import React from 'react';
import {
  Card,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import CardTitle from '../../../common/card/CardTitle';
import GroupIcon from '@material-ui/icons/Group';
import { useFindRoles } from '../../roles/Role.hooks';
import { useFindUser, usePatchUser } from '../../../user/User.hooks';
import { Role } from '../../roles/Role.interface';
import { roles } from '../../../user/User.interface';
import AdminGuard from '../../../guards/admin.guard';

export interface UserRoleCardProps {
  userId: number;
}

const UserRoleCard: React.FC<UserRoleCardProps> = ({ userId }) => {
  const { roleList } = useFindRoles(true);
  const { user: patchedUser, patch } = usePatchUser(userId);
  const { user: origUser } = useFindUser(userId, true);

  const user = patchedUser ? patchedUser : origUser; // initial user versus getting user from patch() response
  return (
    <Card>
      <CardTitle>
        <GroupIcon />
        Role Assignments
      </CardTitle>
      <List>
        {roleList &&
          roleList.data.map(role => {
            if (role.name === 'Admin' && !AdminGuard().canActivate())
              return null;
            return (
              <ListItem
                key={role.id}
                role={undefined}
                dense
                button
                onClick={() => {}}
              >
                <ListItemIcon>
                  <Checkbox
                    edge='start'
                    disableRipple
                    color='primary'
                    checked={
                      user?.roles?.find(g => g.id === role.id) ? true : false
                    }
                    onChange={event => {
                      if (event.target.checked) {
                        user?.roles?.push(role);
                      } else {
                        const filtered =
                          user &&
                          user.roles &&
                          user.roles.filter(g => {
                            return g.id !== role.id;
                          });

                        if (user && user.roles && filtered) {
                          user.roles = filtered as Role[];
                        }
                      }
                      if (user && user.roles) {
                        patch({ roles: user.roles });
                      }
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    roles.find(r => r.name === role.name)?.label || role.name
                  }
                />
              </ListItem>
            );
          })}
      </List>
    </Card>
  );
};

export default UserRoleCard;
